// extracted by mini-css-extract-plugin
export var hero = "blog-post-infinite-module--hero--wOhmH";
export var title = "blog-post-infinite-module--title--x1kFV";
export var adPlaceholder = "blog-post-infinite-module--adPlaceholder--BmuXx";